import React, { PureComponent } from 'react';
import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { bool, func, number } from 'prop-types';
import { InfoWindow, Marker } from 'react-google-maps';
import markerShape from '../../constants/propTypes/markerShape';

class MapMarker extends PureComponent {
  state = {
    isCtrlPressed: false,
  };

  static propTypes = {
    marker: markerShape.isRequired,
    onMarkerClick: func,
    onMarkerHover: func,
    onMarkerDragEnd: func.isRequired,
    markersDragAllowed: bool.isRequired,
    defaultMarkersView: bool,
    onInfoWindowClick: func,
    zOrder: number,
    enableInfoWindowAutoPan: bool,
  };

  static defaultProps = {
    onMarkerClick: () => {},
    onMarkerHover: () => {},
    defaultMarkersView: false,
    enableInfoWindowAutoPan: false,
  };

  getMarkerIcon = () => {
    const { marker, defaultMarkersView } = this.props;
    let icon = '';

    if (marker.markerIcon) {
      icon = marker.markerIcon;
    } else if (!defaultMarkersView) {
      if (marker.isPositionActual === undefined) {
        icon = 'assets/images/marker.png';
      }
      icon =
        Object.prototype.hasOwnProperty.call(marker, 'isPositionActual') && !marker.isPositionActual
          ? 'assets/images/marker_gray.png'
          : 'assets/images/marker.png';
    }

    return icon;
  };

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
    document.addEventListener('keyup', this.handleKeyUp);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('keyup', this.handleKeyUp);
  }

  handleKeyDown = event => {
    if (event.key === 'Control') {
      this.setState({ isCtrlPressed: true });
    }
  };

  handleKeyUp = event => {
    if (event.key === 'Control') {
      this.setState({ isCtrlPressed: false });
    }
  };

  emitClick = state => {
    const { marker, onMarkerClick } = this.props;

    onMarkerClick(marker, state);
  };

  renderInfoWindow = () => {
    const { marker, onInfoWindowClick, zOrder, enableInfoWindowAutoPan } = this.props;
    return (
      !!marker.showInfo &&
      ((marker.showInfo.route && (
        <InfoWindow options={{ disableAutoPan: !enableInfoWindowAutoPan, zIndex: zOrder }}>
          {/* eslint-disable-next-line max-len */}
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <div
            onClick={onInfoWindowClick}
            style={{
              cursor: 'pointer',
              paddingLeft: '7px',
            }}
          >
            {marker.showInfo.content
              ? marker.infoContent.fullInformation
              : marker.infoContent.routeInformation}
          </div>
        </InfoWindow>
      )) ||
        (marker.showInfo &&
          marker.showInfo.content && (
            <InfoWindow
              options={{ disableAutoPan: !enableInfoWindowAutoPan, zIndex: zOrder }}
              onDomReady={onInfoWindowClick}
            >
              {/* eslint-disable-next-line max-len */}
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
              <div
                onClick={onInfoWindowClick}
                style={{
                  cursor: 'pointer',
                }}
              >
                <IconButton
                  color="inherit"
                  sx={{ fontSize: '80%', fontWeight: 400, position: 'absolute' }}
                  style={{
                    height: '16px',
                    width: '16px',
                    right: '8px',
                    top: '8px',
                  }}
                  aria-label="Close"
                  onClick={() => this.emitClick({ infoWindowOpen: true, closeClick: true })}
                >
                  <Close />
                </IconButton>
                <div>{marker.infoContent}</div>
              </div>
            </InfoWindow>
          )))
    );
  };

  render() {
    const { marker, markersDragAllowed, onMarkerDragEnd, onMarkerHover } = this.props;
    const icon = this.getMarkerIcon();
    return (
      // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
      <Marker
        icon={icon}
        position={marker.position}
        draggable={markersDragAllowed}
        options={marker.options}
        label={marker.label || ''}
        onDragEnd={onMarkerDragEnd}
        onClick={() =>
          this.emitClick({
            infoWindowOpen: marker.showInfo && marker.showInfo.content,
            closeClick: false,
          })
        }
        onMouseOver={() => !this.state.isCtrlPressed && onMarkerHover(marker, true)}
        onMouseOut={() => !this.state.isCtrlPressed && onMarkerHover(marker, false)}
      >
        {this.renderInfoWindow()}
      </Marker>
    );
  }
}

export default MapMarker;
